// components/BlogCard.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ blog }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Format date to be more readable
  const formatDate = (dateString) => {
    if (!dateString) return 'No date';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Truncate description to a certain length
  const truncateDescription = (text, maxLength = 80) => {
    if (!text) return 'No description available';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <Link 
      to={`/BlogDetail/${blog.id}`}
      className="relative z-1 overflow-hidden flex flex-col w-[400px] gap-2 transition-all duration-300 cursor-pointer no-underline"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="relative overflow-hidden rounded-t-lg"
        style={{
          backgroundColor: isHovered 
          ? '#b9cf75' 
          : 'transparent',
          transition: 'background-color 0.3s ease'
        }}
      >
        <img 
          src={blog.image || 'https://via.placeholder.com/300x200?text=No+Image'} 
          alt={blog.title || 'Blog post'} 
          className="w-[400px] h-[200px] object-cover"
          style={{
            opacity: isHovered ? 0.5 : 1,
            transition: 'opacity 0.3s ease'
          }}
        />
        {/* Overlay text on hover */}
        {isHovered && (
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="kerning-normal text-tertiary font-semibold px-4 py-2 bg-white bg-opacity-75 rounded-lg">
              Read More →
            </p>
          </div>
        )}
      </div> 
      
      <div className='flex flex-col p-3 flex-grow gap-2'>
        <p className="kerning-normal font-bold text-mm line-clamp-2 mb-2">{blog.title}</p>
        
        <div className='flex flex-row justify-between items-center mb-2'>  
          <p className="kerning-normal font-semibold text-ss text-second py-1">
            {blog.category || 'Uncategorized'}
          </p>   
          <p className="kerning-normal font-semibold text-xs text-gray-500">
            {formatDate(blog.publishDate || blog.createdAt || blog.date)}
          </p>       
        </div>
        
        <p className="kerning-normal font-medium text-ss text-gray-600 line-clamp-3">
          {truncateDescription(blog.content || blog.desc)}
        </p>
      </div>
    </Link>
  );
};

export default BlogCard;